import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../loader.service';
import { AlertDialogService } from '../shared/alert-dialog/alert-dialog.service';
import { SharedService } from '../shared/shared.service';
import { ToasterService } from '../toaster.service';
import { Toaster, ToasterType } from '../shared/types/toaster.types';
import { SubscriptionService } from './subscription.service';
import { planTypeFromRule, servicesForExclusion, skipServiceHierarchyForMode, eligibleRuleTypesFromRule, displayTitlesFromRule, exclusiveOfTaxFromRule, applicableConfig } from './subscription.applicable-types';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';
var SubscriptionComponent = /** @class */ (function () {
    function SubscriptionComponent(toasterService, route, router, sharedService, subsService, loader, alertService, authzAccessHintService) {
        this.toasterService = toasterService;
        this.route = route;
        this.router = router;
        this.sharedService = sharedService;
        this.subsService = subsService;
        this.loader = loader;
        this.alertService = alertService;
        this.authzAccessHintService = authzAccessHintService;
        this.subscriptionType = 'accessFee';
        this.authzAccessHint = null;
        this.launchParams = null;
        this.hasSwitchedTab = false;
        this.launchResolved = false;
        this.configFormGroup = new FormGroup({
            creationFlow: new FormControl('earningModel'),
            state: new FormControl(null),
            city: new FormControl(null),
            mode: new FormControl(null),
            category: new FormControl(null),
            service: new FormControl(null)
        });
        this.states = [];
        this.cities = [];
        this.modes = [];
        this.categories = [];
        this.services = [];
        this.applicablePlans = [];
        this.matchedRule = null;
        this.trialEnabledForSelectedCategory = false;
        this.allServices = [];
        this.configsBySdid = {};
        this.applicableFetchId = 0;
        this.trialCategoryFetchId = 0;
        this.skipServiceHierarchyToggle = {};
    }
    SubscriptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAccessHint();
        var q = (this.route.snapshot && this.route.snapshot.queryParams) || {};
        var city = (q['city'] || '').trim();
        if (city) {
            this.launchParams = { city: city, service: (q['service'] || '').trim() };
        }
        this.configFormGroup.get('creationFlow').valueChanges.subscribe(function () { return _this.onCreationFlowChange(); });
        this.configFormGroup.get('state').valueChanges.subscribe(function () { return _this.onStateChange(); });
        this.configFormGroup.get('city').valueChanges.subscribe(function () { return _this.onCityChange(); });
        this.configFormGroup.get('mode').valueChanges.subscribe(function () { return _this.onModeChange(); });
        this.configFormGroup.get('category').valueChanges.subscribe(function () { return _this.onCategoryChange(); });
        this.configFormGroup.get('service').valueChanges.subscribe(function () { return _this.onServiceChange(); });
        this.loadInitialData();
    };
    SubscriptionComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('subscription')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SubscriptionComponent.prototype, "postpaidContext", {
        get: function () {
            var state = this.configFormGroup.get('state').value;
            var city = this.configFormGroup.get('city').value;
            var mode = this.configFormGroup.get('mode').value;
            var category = this.configFormGroup.get('category').value;
            var service = this.configFormGroup.get('service').value;
            if (!state || !city || !mode || !category || !service) {
                return null;
            }
            return {
                state: state,
                city: city,
                mode: mode,
                category: category.id,
                categoryServices: this.services,
                excludableServices: servicesForExclusion(this.configsBySdid, this.services),
                displayTitles: displayTitlesFromRule(this.matchedRule),
                exclusiveOfTax: exclusiveOfTaxFromRule(this.matchedRule),
                eligibleRuleTypes: eligibleRuleTypesFromRule(this.matchedRule, ['zeroCommission'])
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "prepaidContext", {
        get: function () {
            var city = this.configFormGroup.get('city').value;
            var mode = this.configFormGroup.get('mode').value;
            var category = this.configFormGroup.get('category').value;
            var service = this.configFormGroup.get('service').value;
            if (!city || !mode || !category || !service) {
                return null;
            }
            var applicable = applicableConfig(this.matchedRule) || {};
            return {
                city: city,
                mode: mode,
                service: service,
                modeServices: this.allServices,
                categoryServices: this.services,
                skipServiceHierarchy: skipServiceHierarchyForMode(this.skipServiceHierarchyToggle, mode.id, city.id),
                autoAssignmentTriggers: applicable.autoAssignmentTriggers || [],
                allowSuspendServicesPostExpiry: applicable.allowSuspendServicesPostExpiry === true,
                alwaysSuspendServicesPostExpiry: applicable.alwaysSuspendServicesPostExpiry === true,
                allowDefaultSubscription: applicable.allowDefaultSubscription === true,
                eligibleRuleTypes: eligibleRuleTypesFromRule(this.matchedRule, ['zeroCommission']),
                displayTitles: displayTitlesFromRule(this.matchedRule),
                exclusiveOfTax: exclusiveOfTaxFromRule(this.matchedRule)
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "daprContext", {
        get: function () {
            var city = this.configFormGroup.get('city').value;
            var mode = this.configFormGroup.get('mode').value;
            if (!city || !mode) {
                return null;
            }
            return {
                city: city,
                mode: mode,
                modeServices: this.allServices,
                exclusiveOfTax: false
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "trialContext", {
        get: function () {
            var city = this.configFormGroup.get('city').value;
            var mode = this.configFormGroup.get('mode').value;
            var category = this.configFormGroup.get('category').value;
            var service = this.configFormGroup.get('service').value;
            if (!city || !mode || !category || !service) {
                return null;
            }
            var categoryServices = this.allServices.filter(function (serviceItem) { return String(serviceItem.categoryId) === String(category.id); });
            return {
                city: city,
                mode: mode,
                category: category,
                service: service,
                modeServices: categoryServices
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "isDaprResetMe", {
        get: function () {
            return this.configFormGroup.get('creationFlow').value === 'daprResetMe';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "isTrialSubs", {
        get: function () {
            return this.configFormGroup.get('creationFlow').value === 'trialSubs';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "isStandaloneCreationFlow", {
        get: function () {
            return this.isDaprResetMe || this.isTrialSubs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "showParentService", {
        get: function () {
            return !this.isDaprResetMe && !this.isTrialSubs && !this.isPlanLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "showAccessFee", {
        get: function () {
            return !this.isStandaloneCreationFlow && this.subscriptionType === 'accessFee' && this.isPlanApplicable('accessFee');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "showEarningPrepaid", {
        get: function () {
            return !this.isStandaloneCreationFlow && this.subscriptionType === 'subscription' && this.isPlanApplicable('subscription') && !!this.prepaidContext;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "showDaprPrepaid", {
        get: function () {
            return this.isDaprResetMe && !!this.daprContext;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "showTrialSubs", {
        get: function () {
            return this.isTrialSubs && this.trialEnabledForSelectedCategory && !!this.trialContext;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "showPostpaid", {
        get: function () {
            return !this.isStandaloneCreationFlow && this.subscriptionType === 'postpaid' && this.isPlanApplicable('postpaid');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "isPlanLoaded", {
        get: function () {
            return this.applicablePlans.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "accessFeeContext", {
        get: function () {
            var city = this.configFormGroup.get('city').value;
            var mode = this.configFormGroup.get('mode').value;
            var category = this.configFormGroup.get('category').value;
            var service = this.configFormGroup.get('service').value;
            if (!city || !mode || !service) {
                return null;
            }
            return {
                city: city,
                mode: mode,
                category: category,
                service: service,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubscriptionComponent.prototype, "accessFeeLaunch", {
        get: function () {
            var city = this.configFormGroup.get('city').value;
            var service = this.configFormGroup.get('service').value;
            if (city && service) {
                return { city: city.id, service: service.id };
            }
            return this.launchParams;
        },
        enumerable: true,
        configurable: true
    });
    SubscriptionComponent.prototype.isPlanApplicable = function (plan) {
        return this.applicablePlans.indexOf(plan) !== -1;
    };
    SubscriptionComponent.prototype.onLaunchConsumed = function () {
        this.launchResolved = true;
        this.launchParams = null;
    };
    SubscriptionComponent.prototype.onManualTabChange = function () {
        this.onLaunchConsumed();
    };
    SubscriptionComponent.prototype.onLaunchServiceUnavailable = function () {
        if (this.launchResolved) {
            return;
        }
        if (!this.hasSwitchedTab) {
            this.hasSwitchedTab = true;
            this.subscriptionType = this.subscriptionType === 'accessFee' ? 'subscription' : 'accessFee';
            return;
        }
        this.onLaunchConsumed();
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: 'Service from URL is not available for subscription creation.'
        }));
    };
    SubscriptionComponent.prototype.loadInitialData = function () {
        var _this = this;
        this.loader.openLoading();
        Promise.all([
            this.sharedService.fetchStatesAndCities().toPromise(),
            this.subsService.getSkipServiceHierarchyToggle().toPromise().catch(function () { return ({ data: {} }); })
        ]).then(function (_a) {
            var statesRes = _a[0], skipRes = _a[1];
            _this.states = (statesRes && statesRes.data && statesRes.data.states) || [];
            _this.skipServiceHierarchyToggle = (skipRes && skipRes.data) || skipRes || {};
            return _this.applyLaunchPrefill();
        }).catch(function (err) {
            console.error('Failed to load states or applicable types', err);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load states.'
            }));
        }).finally(function () { return _this.loader.closeLoading(); });
    };
    SubscriptionComponent.prototype.findLaunchStateAndCity = function (cityId) {
        var matchedState = null;
        var matchedCity = null;
        (this.states || []).forEach(function (state) {
            var city = (state.cities || []).find(function (c) { return String(c.id) === String(cityId); });
            if (city && !matchedCity) {
                matchedState = state;
                matchedCity = city;
            }
        });
        return matchedState ? { state: matchedState, city: matchedCity } : null;
    };
    SubscriptionComponent.prototype.unwrapServiceDetail = function (item) {
        return item && item.data ? item.data : item;
    };
    SubscriptionComponent.prototype.categoryFromServiceDetail = function (data) {
        var service = (data && data.service) || {};
        var candidates = [data && data.category, data && data.serviceCategory, service.category];
        for (var i = 0; i < candidates.length; i++) {
            var raw = candidates[i];
            if (raw && typeof raw === 'object') {
                return {
                    id: String(raw._id || raw.id || raw.name),
                    name: String(raw.name || raw.displayName || raw._id || raw.id)
                };
            }
            if (typeof raw === 'string' && raw) {
                return { id: raw, name: raw };
            }
        }
        var name = service.categoryName || (data && data.categoryName);
        return name ? { id: String(name), name: String(name) } : null;
    };
    SubscriptionComponent.prototype.matchServiceDetail = function (details, cityId, serviceId) {
        var _this = this;
        var rows = (details || []).map(function (item) { return _this.unwrapServiceDetail(item); }).filter(function (data) {
            if (!data) {
                return false;
            }
            var itemCity = data.city && (data.city._id || data.city.id);
            if (String(itemCity) !== String(cityId)) {
                return false;
            }
            var service = data.service || {};
            var svcId = service._id || service.id;
            return String(svcId) === String(serviceId) || String(data._id) === String(serviceId);
        });
        return rows.find(function (row) { return row.active !== false; }) || rows[0] || null;
    };
    SubscriptionComponent.prototype.applyLaunchPrefill = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var cityId, serviceId, found, detailsRes, row, modeId_1, modeName, categoryHint_1, modesRes, mode_1, optionsRes, category_1, service, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cityId = this.launchParams && this.launchParams.city;
                        serviceId = this.launchParams && this.launchParams.service;
                        if (!cityId) {
                            return [2 /*return*/];
                        }
                        found = this.findLaunchStateAndCity(cityId);
                        if (!found) {
                            this.toasterService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: 'City from URL is not available.'
                            }));
                            return [2 /*return*/];
                        }
                        this.configFormGroup.get('state').setValue(found.state, { emitEvent: false });
                        this.cities = found.state.cities || [];
                        this.configFormGroup.get('city').setValue(found.city, { emitEvent: false });
                        if (!serviceId) {
                            this.onCityChange();
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.sharedService.fetchAllServiceDetails().toPromise()];
                    case 2:
                        detailsRes = _a.sent();
                        row = this.matchServiceDetail((detailsRes && detailsRes.data) || detailsRes || [], cityId, serviceId);
                        if (!row) {
                            this.toasterService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: 'Service from URL is not available.'
                            }));
                            this.onCityChange();
                            return [2 /*return*/];
                        }
                        modeId_1 = row.modeInfo && (row.modeInfo._id || row.modeInfo.id);
                        modeName = row.modeInfo && (row.modeInfo.mode || row.modeInfo.name);
                        categoryHint_1 = this.categoryFromServiceDetail(row);
                        if (!modeId_1 || !categoryHint_1) {
                            this.toasterService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: 'Could not resolve mode and category from service.'
                            }));
                            this.onCityChange();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.sharedService.fetchModes(cityId).toPromise()];
                    case 3:
                        modesRes = _a.sent();
                        this.modes = (modesRes && modesRes.data && modesRes.data.modes) || [];
                        mode_1 = this.modes.find(function (item) { return String(item.id) === String(modeId_1); })
                            || { id: String(modeId_1), name: modeName || String(modeId_1) };
                        if (!this.modes.some(function (item) { return String(item.id) === String(mode_1.id); })) {
                            this.modes = this.modes.concat([mode_1]);
                        }
                        this.configFormGroup.get('mode').setValue(mode_1, { emitEvent: false });
                        return [4 /*yield*/, this.sharedService.fetchSubscriptionServiceOptions(cityId, mode_1.id).toPromise()];
                    case 4:
                        optionsRes = _a.sent();
                        this.categories = (optionsRes && optionsRes.data && optionsRes.data.categories) || [];
                        this.allServices = (optionsRes && optionsRes.data && optionsRes.data.services) || [];
                        category_1 = this.categories.find(function (item) { return String(item.id) === String(categoryHint_1.id); }) || categoryHint_1;
                        if (!this.categories.some(function (item) { return String(item.id) === String(category_1.id); })) {
                            this.categories = this.categories.concat([category_1]);
                        }
                        this.configFormGroup.get('category').setValue(category_1, { emitEvent: false });
                        this.services = this.allServices.filter(function (item) { return String(item.categoryId) === String(category_1.id); });
                        service = this.services.find(function (item) {
                            return String(item.id) === String(serviceId) || String(item.serviceDetailId) === String(serviceId);
                        });
                        if (!service) {
                            this.toasterService.showToaster(new Toaster({
                                type: ToasterType.WARNING,
                                message: 'Service from URL is not available.'
                            }));
                            return [2 /*return*/];
                        }
                        this.configFormGroup.get('service').setValue(service);
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        console.error('Launch prefill failed', err_1);
                        this.toasterService.showToaster(new Toaster({
                            type: ToasterType.WARNING,
                            message: 'Could not prefill city and service from URL.'
                        }));
                        this.onCityChange();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SubscriptionComponent.prototype.resetDownstream = function (controls) {
        var _this = this;
        this.applicableFetchId++;
        controls.forEach(function (name) { return _this.configFormGroup.get(name).setValue(null, { emitEvent: false }); });
        this.applicablePlans = [];
        this.matchedRule = null;
        this.configsBySdid = {};
        if (this.isTrialSubs && (controls.indexOf('mode') >= 0 || controls.indexOf('category') >= 0)) {
            this.trialEnabledForSelectedCategory = false;
        }
    };
    SubscriptionComponent.prototype.invalidateTrialSelection = function () {
        if (!this.isTrialSubs) {
            return;
        }
        this.trialCategoryFetchId++;
        this.trialEnabledForSelectedCategory = false;
    };
    SubscriptionComponent.prototype.syncSelectionInUrl = function () {
        var city = this.configFormGroup.get('city').value;
        var service = this.configFormGroup.get('service').value;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                city: city && city.id ? city.id : null,
                service: service && service.id ? service.id : null
            },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    };
    SubscriptionComponent.prototype.onCreationFlowChange = function () {
        this.trialEnabledForSelectedCategory = false;
        this.invalidateTrialSelection();
        this.onServiceChange();
    };
    SubscriptionComponent.prototype.onStateChange = function () {
        var state = this.configFormGroup.get('state').value;
        this.cities = state && state.cities ? state.cities : [];
        this.modes = [];
        this.categories = [];
        this.services = [];
        this.allServices = [];
        this.resetDownstream(['city', 'mode', 'category', 'service']);
        this.syncSelectionInUrl();
    };
    SubscriptionComponent.prototype.onCityChange = function () {
        var _this = this;
        var city = this.configFormGroup.get('city').value;
        this.invalidateTrialSelection();
        this.modes = [];
        this.categories = [];
        this.services = [];
        this.allServices = [];
        this.resetDownstream(['mode', 'category', 'service']);
        this.syncSelectionInUrl();
        if (!city) {
            return;
        }
        this.loader.openLoading();
        this.sharedService.fetchModes(city.id).toPromise()
            .then(function (res) {
            _this.modes = (res && res.data && res.data.modes) || [];
        })
            .catch(function (err) {
            console.error('Failed to load modes', err);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load modes for city.'
            }));
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    SubscriptionComponent.prototype.onModeChange = function () {
        var _this = this;
        var city = this.configFormGroup.get('city').value;
        var mode = this.configFormGroup.get('mode').value;
        this.categories = [];
        this.services = [];
        this.allServices = [];
        this.invalidateTrialSelection();
        this.resetDownstream(['category', 'service']);
        this.syncSelectionInUrl();
        if (!city || !mode) {
            return;
        }
        this.loader.openLoading();
        this.sharedService.fetchSubscriptionServiceOptions(city.id, mode.id).toPromise()
            .then(function (res) {
            _this.categories = (res && res.data && res.data.categories) || [];
            _this.allServices = (res && res.data && res.data.services) || [];
        })
            .catch(function (err) {
            console.error('Failed to load categories and services', err);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load categories for mode.'
            }));
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    SubscriptionComponent.prototype.onCategoryChange = function () {
        var category = this.configFormGroup.get('category').value;
        this.invalidateTrialSelection();
        this.services = category
            ? this.allServices.filter(function (service) { return String(service.categoryId) === String(category.id); })
            : [];
        this.resetDownstream(['service']);
        this.subscriptionType = null;
        this.syncSelectionInUrl();
    };
    SubscriptionComponent.prototype.onServiceChange = function () {
        var _this = this;
        this.applicableFetchId++;
        var city = this.configFormGroup.get('city').value;
        var mode = this.configFormGroup.get('mode').value;
        var category = this.configFormGroup.get('category').value;
        var service = this.configFormGroup.get('service').value;
        this.applicablePlans = [];
        this.matchedRule = null;
        this.subscriptionType = null;
        this.configsBySdid = {};
        this.syncSelectionInUrl();
        if (!city || !mode) {
            return;
        }
        if (this.isDaprResetMe) {
            this.subscriptionType = 'subscription';
            this.applicablePlans = ['subscription'];
            return;
        }
        if (this.isTrialSubs) {
            if (!category || !service) {
                this.trialEnabledForSelectedCategory = false;
                return;
            }
            this.trialCategoryFetchId++;
            this.trialEnabledForSelectedCategory = false;
            var sdid_1 = service.serviceDetailId;
            var fetchId_1 = this.trialCategoryFetchId;
            this.loader.openLoading();
            this.subsService.getApplicableTypes([sdid_1], mode.id).toPromise()
                .then(function (res) {
                if (fetchId_1 !== _this.trialCategoryFetchId || !_this.isTrialSubs) {
                    return;
                }
                var selected = _this.configFormGroup.get('service').value;
                if (!selected || String(selected.serviceDetailId) !== String(sdid_1)) {
                    return;
                }
                var config = (res && res.data && res.data[String(sdid_1)]) || null;
                if (!config || config.eligibleForTrial !== true) {
                    _this.configFormGroup.get('service').setValue(null, { emitEvent: false });
                    _this.alertService.open({
                        title: 'Trial not enabled',
                        message: "Trial is not enabled for mode \"" + mode.name + "\", category \"" + category.name + "\", service \"" + service.name + "\"."
                    });
                    return;
                }
                _this.trialEnabledForSelectedCategory = true;
            })
                .catch(function (err) {
                if (fetchId_1 !== _this.trialCategoryFetchId) {
                    return;
                }
                console.error('Failed to validate trial selection', err);
                _this.configFormGroup.get('service').setValue(null, { emitEvent: false });
                _this.alertService.open({
                    title: 'Trial not enabled',
                    message: "Could not load trial config for mode \"" + mode.name + "\", category \"" + category.name + "\", service \"" + service.name + "\"."
                });
            })
                .finally(function () {
                if (fetchId_1 === _this.trialCategoryFetchId) {
                    _this.loader.closeLoading();
                }
            });
            return;
        }
        if (!category || !service) {
            return;
        }
        var sdids = this.services.map(function (item) { return item.serviceDetailId; }).filter(Boolean);
        if (!sdids.length) {
            return;
        }
        var fetchId = this.applicableFetchId;
        var loadingTask = "subscription-applicable-" + fetchId;
        this.loader.openLoading(loadingTask);
        this.subsService.getApplicableTypes(sdids, mode.id).toPromise()
            .then(function (res) {
            if (fetchId !== _this.applicableFetchId || _this.isStandaloneCreationFlow) {
                return;
            }
            _this.configsBySdid = (res && res.data) || {};
            var config = _this.configsBySdid[service.serviceDetailId] || null;
            _this.matchedRule = config ? { applicableType: config } : null;
            var planType = planTypeFromRule(_this.matchedRule);
            _this.subscriptionType = planType;
            _this.applicablePlans = planType ? [planType] : [];
            if (!planType) {
                _this.alertService.open({
                    title: 'Not eligible',
                    message: 'This service is not eligible for any type of subscription. If that\'s a mistake, contact @captain-retention-be-devs in the #captain-retention-team Slack channel'
                });
            }
        })
            .catch(function (err) {
            if (fetchId !== _this.applicableFetchId || _this.isStandaloneCreationFlow) {
                return;
            }
            console.error('Failed to load applicable type', err);
            _this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: 'Could not load applicable type for service.'
            }));
        })
            .finally(function () {
            _this.loader.closeLoading(loadingTask);
        });
    };
    return SubscriptionComponent;
}());
export { SubscriptionComponent };
